import { render, staticRenderFns } from "./SetFiles.vue?vue&type=template&id=39f83d81&scoped=true"
import script from "./SetFiles.vue?vue&type=script&lang=js"
export * from "./SetFiles.vue?vue&type=script&lang=js"
import style0 from "./SetFiles.vue?vue&type=style&index=0&id=39f83d81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f83d81",
  null
  
)

export default component.exports